export default {
  title: 'Lisää tiedosto: {{slot}}',
  replace_title: 'Korvaa tiedosto: {{slot}}',
  replace_description: 'Uusi tiedosto korvaa tämän. Säilytämme vanhan arkistossamme.',
  form: {
    kind: {
      label: 'Henkilöllisyystodistuksen tyyppi',
      options: {
        passport: 'Passi',
        driver_license: 'Ajokortti',
        id_card: 'Henkilökortti',
        residence_permit: 'Oleskelulupa',
      },
    },
    front: {
      label: 'Etupuoli',
    },
    back: {
      label: 'Takapuoli',
    },
    file: {
      label: 'Tiedosto',
    },
    expires_at: {
      label: 'Voimassa asti',
      placeholder: 'Valitse päivämäärä',
    },
    holder: {
      label: 'Kenen henkilöllisyystodistus tämä on?',
      options: {
        owner: 'Minun, omistajan',
        partner: 'Kumppanin',
      },
    },
    holder_name: {
      label: 'Kumppanin nimi',
      placeholder: 'Etu- ja sukunimi',
    },
  },
  accepted_files: 'PDF, JPG tai PNG, enintään {{max}} Mt.',
  accepted_images_min: 'Kuvan on oltava vähintään {{min}} kt.',
  errors: {
    file_type: 'Vain PDF-, JPG- tai PNG-tiedostot hyväksytään.',
    file_too_large: 'Tiedosto on suurempi kuin {{max}} Mt.',
    file_too_small: 'Kuvan on oltava vähintään {{min}} kt.',
  },
  buttons: {
    select_file: 'Valitse tiedosto',
    submit: 'Lataa',
    cancel: 'Peruuta',
  },
  toasts: {
    success: 'Tiedosto ladattu',
    error: 'Tiedostoa ei voitu ladata.',
  },
};
